import ProjectData from "@/data/ProjectData.ts";

const pieceBuilderProject = new ProjectData(
  "project-4",
  "Construction Set - 3D Builder",
  "img/projects/PieceBuilder/piecebuilder1.jpg",
  `
    <div class="paragraph">
        <strong>Construction Set - 3D Builder</strong> - A relaxing 3D puzzle game where you build brick by brick.
        <br/><br/>
        Design and construct everything from cozy cabins to towering skyscrapers. Assemble various brick scenes in this classic constructor game. Play for free and offline!
    </div>
    
    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/PieceBuilder/piecebuilder2.jpg" alt="Construction Set Gameplay" />
    </div>
    
    <div class="paragraph center">
        <a href="https://tonkin.itch.io/piece-builder" target="_blank">
            <img src="img/itchiologo.svg" alt="Available on itch.io" class="platform-logo" />
        </a>
    </div>

    <div class="paragraph">
        <strong>Game Features:</strong>
        <ul>
        <li><strong>Engaging Puzzles:</strong> Combine, rotate, and arrange 3D shapes to match blueprints</li>
        <li><strong>Multiple Themes:</strong> Build in forests, cities, and more unique environments</li>
        <li><strong>Unlockables:</strong> Earn new materials, textures, colors, and shapes</li>
        <li><strong>Realistic Physics:</strong> Structures are visually stunning and stable</li>
        <li><strong>Relaxing Gameplay:</strong> Soothing music and calming experience</li>
        <li><strong>Creative Freedom:</strong> Build houses, castles, animals, vehicles, and more</li>
        </ul>
    </div>

    <div class="paragraph">
        <strong>What I Built:</strong>
        <ul>
        <li><strong>3D Puzzle Mechanics:</strong> Core rotation and piece-matching system with intuitive mobile controls</li>
        <li><strong>Validation System:</strong> Checks correct placement and validates completed structures</li>
        <li><strong>Progression:</strong> Unlocking system for new materials and themes</li>
        <li><strong>Physics:</strong> Realistic stability and natural responses for structures</li>
        <li><strong>Level Design:</strong> Puzzles ranging from simple builds to complex architecture</li>
        <li><strong>Offline Play:</strong> Optimized to work without internet</li>
        </ul>
    </div>
    
    <div class="paragraph">
        <div class="notice">
        <strong>Build Your World, Brick by Brick!</strong> Available now on itch.io!
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/PieceBuilder/piecebuilder3.jpg" alt="Construction Set Building" />
        <img class="pc-screenshot" src="img/projects/PieceBuilder/piecebuilder2.jpg" alt="Construction Set Themes" />
    </div>
    `,
  "#FF6B35",
  false
);

export default pieceBuilderProject;
